import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "components/layouts/DashboardLayout";
import { useAuth } from "context/AuthContext";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const AdminRouter: React.FC<PrivateRouteProps> = ({ children, ...rest }) => {
  const { fetchUserData, user } = useAuth();
  const theStoredToken = localStorage.getItem("accessToken");
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    fetchUserData(token as string);
  }, []);

  if (!user._id && !theStoredToken) {
    return <Navigate to="/login" />;
  }

  return <DashboardLayout>{children}</DashboardLayout>;
};

export default AdminRouter;
